import api from '@seller-hermes/utils/api';
import {
  CreateSellerMarkerDto,
  SellerMarker,
  UpdateSellerMarkerDto,
} from './seller-markers.dto';

export type AssignSellerMarkersToSellerDto = {
  sellers_ids: string[];
  tags_ids: string[];
};

export type UnassignSellerMarkersFromSellerDto =
  AssignSellerMarkersToSellerDto;

export class SellerMarkersQuery {
  static getMarkersList = async (): Promise<SellerMarker[]> => {
    const response = await api.get('/seller-group/seller-tags');
    return response.data;
  };

  static createMarker = async (
    data: CreateSellerMarkerDto,
  ): Promise<SellerMarker> => {
    const response = await api.post('/seller-group/seller-tag', data);
    return response.data;
  };

  static updateMarker = async (
    data: UpdateSellerMarkerDto,
  ): Promise<SellerMarker> => {
    const response = await api.patch('/seller-group/seller-tag', data);
    return response.data;
  };

  static assignMarkersToSeller = async (
    data: AssignSellerMarkersToSellerDto,
  ): Promise<void> => {
    const response = await api.patch('/seller/seller-tags/assign', data);
    return response.data;
  };

  static unassignMarkersFromSeller = async (
    data: UnassignSellerMarkersFromSellerDto,
  ): Promise<void> => {
    const response = await api.patch('/seller/seller-tags/unassign', data);
    return response.data;
  };
}
